import { useState } from "react";
import { MailWarning, Loader2, Check } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyBanner({ user, className = "" }) {
  const [state, setState] = useState("idle");
  const [msg, setMsg] = useState("");

  if (!user || user.email_verified !== false) return null;

  const handleResend = async () => {
    setState("sending");
    try {
      await axios.post(`${API}/auth/resend-verification`, {}, { withCredentials: true });
      setState("sent");
      setTimeout(() => setState("idle"), 60000);
    } catch (err) {
      setMsg(err.response?.data?.detail || "Could not send email. Try again shortly.");
      setState("error");
    }
  };

  return (
    <div data-testid="verify-banner" className={`relative z-20 mx-4 sm:mx-8 mt-3 ${className}`}>
      <div className="max-w-7xl mx-auto flex flex-wrap items-center gap-3 px-5 py-3 rounded-2xl bg-amber-500/10 border border-amber-400/25 backdrop-blur-sm">
        <MailWarning size={16} className="text-amber-400 shrink-0" />
        <p className="text-xs sm:text-sm text-amber-200 flex-1 min-w-[200px]">
          Verify your email to start weaving stories — we sent a magical link to <span className="font-semibold">{user.email}</span>
        </p>
        {state === "sent" ? (
          <span className="flex items-center gap-1.5 text-xs text-emerald-300 font-medium">
            <Check size={13} /> Email sent — check your inbox
          </span>
        ) : (
          <button
            data-testid="resend-verification-btn"
            onClick={handleResend}
            disabled={state === "sending"}
            className="flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-amber-500 text-black text-xs font-bold hover:bg-amber-400 transition-colors disabled:opacity-50"
          >
            {state === "sending" && <Loader2 size={12} className="animate-spin" />}
            Resend Link
          </button>
        )}
        {state === "error" && <p className="w-full text-xs text-red-400">{msg}</p>}
      </div>
    </div>
  );
}
